module.exports = __webpack_public_path__ + "img/stock1.5b1f3e7a.png";